import { Check, MessageCircle } from "lucide-react";
import Reveal from "@/components/site/Reveal";
import { CONTACT } from "@/lib/site";
import { useT } from "@/lib/i18n";

const SesionCalBooking = () => {
  const t = useT();
  return (
    <section
      id="solicitar"
      className="py-20 md:py-28 bg-charcoal text-ivory grain scroll-mt-24"
      data-testid="cal-booking-section"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-14 items-start">
          <Reveal className="lg:col-span-4">
            <p className="text-[11px] tracking-[0.32em] uppercase text-terracotta mb-5">{t("free.cal.eyebrow")}</p>
            <h2 className="font-serif text-4xl md:text-5xl leading-[1.05]">
              {t("free.cal.title1")} <span className="italic text-terracotta">{t("free.cal.title2")}</span>.
            </h2>
            <p className="mt-6 text-ivory/70 leading-relaxed text-[15.5px]">
              {t("free.cal.body")}
            </p>
            <ul className="mt-8 space-y-3.5 text-[14.5px] text-ivory/80">
              <li className="flex items-start gap-3">
                <Check size={16} className="text-terracotta shrink-0 mt-0.5" /> {t("free.cal.bullet1")}
              </li>
              <li className="flex items-start gap-3">
                <Check size={16} className="text-terracotta shrink-0 mt-0.5" /> {t("free.cal.bullet2")}
              </li>
              <li className="flex items-start gap-3">
                <Check size={16} className="text-terracotta shrink-0 mt-0.5" /> {t("free.cal.bullet3")}
              </li>
            </ul>
            <div className="mt-10 pt-8 border-t border-ivory/10">
              <p className="text-[11px] tracking-[0.3em] uppercase text-ivory/45 mb-3">{t("free.cal.altLabel")}</p>
              <a
                href={CONTACT.whatsappUrl}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="cal-section-whatsapp"
                className="inline-flex items-center gap-3 text-ivory hover:text-terracotta transition-colors"
              >
                <MessageCircle size={18} /> WhatsApp · {CONTACT.whatsappDisplay}
              </a>
            </div>
          </Reveal>

          <Reveal delay={0.1} className="lg:col-span-8">
            <div className="bg-ivory rounded-3xl overflow-hidden border border-ivory/10 shadow-2xl shadow-charcoal/20">
              <iframe
                title="Reservar sesión gratuita 15 min · Método TAO"
                src={CONTACT.calLink}
                className="w-full block"
                style={{ height: "780px", border: 0 }}
                data-testid="cal-iframe"
                loading="lazy"
              />
            </div>
            <p className="mt-4 text-center text-[12px] text-ivory/45">
              {t("free.cal.iframeFallback")}{" "}
              <a
                href={CONTACT.calLink}
                target="_blank"
                rel="noopener noreferrer"
                className="underline hover:text-terracotta"
                data-testid="cal-direct-link"
              >
                {t("free.cal.iframeOpen")}
              </a>
              .
            </p>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default SesionCalBooking;
